<label *ngIf="label()" class="xp-date-range__label" [attr.for]="inputId()">{{ label() }}</label>
<div #fieldBox class="xp-date-range__field" [class.xp-date-range__field--clearable]="range().start">
	<input class="xp-date-range__input"
	       type="text"
	       readonly
	       aria-haspopup="dialog"
	       [attr.id]="inputId()"
	       [attr.aria-expanded]="open()"
	       [value]="text()"
	       [placeholder]="placeholder()"
	       (click)="openPanel()"
	       (focus)="openPanel()" />
	<button *ngIf="range().start"
	        type="button"
	        class="xp-date-range__clear"
	        aria-label="Clear the date range"
	        (click)="clear()">
		<mat-icon>close</mat-icon>
	</button>
	<button type="button"
	        class="xp-date-range__button"
	        aria-label="Choose a date range"
	        (click)="togglePanel()">
		<mat-icon>calendar_today</mat-icon>
	</button>
</div>
<ng-container #panelOutlet></ng-container>
<ng-template #panelTemplate>
	<div class="xp-date-range__panel" role="dialog" [attr.aria-label]="label() || 'Choose a date range'">
		<div class="xp-date-range__months">
			<mat-calendar #leftCalendar
			              class="xp-date-range__month xp-date-range__month--left"
			              [headerComponent]="header"
			              [startAt]="leftMonth()"
			              [selected]="selected()"
			              (selectedChange)="onDateSelected($event)"></mat-calendar>
			<mat-calendar #rightCalendar
			              class="xp-date-range__month xp-date-range__month--right"
			              [headerComponent]="header"
			              [startAt]="rightMonth()"
			              [selected]="selected()"
			              (selectedChange)="onDateSelected($event)"></mat-calendar>
		</div>
		<div *ngIf="presets().length" class="xp-date-range__presets">
			<button *ngFor="let preset of presets()"
			        mat-button
			        type="button"
			        class="xp-date-range__preset"
			        [class.xp-date-range__preset--active]="preset.value === activePreset()"
			        (click)="selectPreset(preset.value)">{{ preset.label }}</button>
		</div>
	</div>
</ng-template>
